const longDateFormatter = new Intl.DateTimeFormat("pt-BR", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

const monthFormatter = new Intl.DateTimeFormat("pt-BR", { month: "long" });
const dayMonthFormatter = new Intl.DateTimeFormat("pt-BR", { day: "numeric", month: "long" });

const isSameDay = (first: Date, second: Date) =>
  first.getFullYear() === second.getFullYear()
  && first.getMonth() === second.getMonth()
  && first.getDate() === second.getDate();

const joinDays = (days: number[]) => {
  if (days.length === 2) return `${days[0]} e ${days[1]}`;
  return `${days.slice(0, -1).join(", ")} e ${days[days.length - 1]}`;
};

export const formatEventDateRange = (startsAt: string, endsAt?: string | null) => {
  const start = new Date(startsAt);
  const end = endsAt ? new Date(endsAt) : null;

  if (!end || isSameDay(start, end)) return longDateFormatter.format(start);

  const startDay = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
  const endDay = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  const dayCount = Math.round((endDay - startDay) / 86400000) + 1;
  const sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();

  if (sameMonth && dayCount > 1 && dayCount <= 10) {
    const days = Array.from({ length: dayCount }, (_, index) => start.getDate() + index);
    return `${joinDays(days)} de ${monthFormatter.format(start)}`;
  }

  if (start.getFullYear() === end.getFullYear()) {
    return `${dayMonthFormatter.format(start)} a ${longDateFormatter.format(end)}`;
  }

  return `${longDateFormatter.format(start)} a ${longDateFormatter.format(end)}`;
};
